import { useState, useEffect, useMemo } from 'react';
import { useIsReadOnly } from '../../../../../store/reportStore';
import { useAddMinistryTeam } from '../hooks/useAddMinistryTeam';
import { validateText } from '../../../../../utils/common';
import { MinistryTeam } from '../types/ministryTeam';
import styles from '../MinistryTeam1000.module.css';

const DEFAULT_MINISTRY_TEAM: MinistryTeam = {
  name: '',
};

/**
 * 사역팀 입력 폼 컴포넌트
 */
export const MinistryTeamInputForm = () => {
  const isReadOnly = useIsReadOnly();
  const { addMinistryTeam, isLoading, error: addError, clearError } = useAddMinistryTeam();

  const [ministryTeamForm, setMinistryTeamForm] = useState<MinistryTeam>(DEFAULT_MINISTRY_TEAM);
  const [isSendable, setIsSendable] = useState(false);

  /**
   * 폼 필드 업데이트 헬퍼 함수
   */
  const updateField = (field: keyof MinistryTeam, value: string) => {
    setMinistryTeamForm((prev) => ({ ...prev, [field]: value }));
  };

  /**
   * 사역팀 추가 버튼 클릭 시 사역팀 추가
   */
  const handleAddMinistryTeam = () => {
    if (!ministryTeamForm.name) return;

    addMinistryTeam(ministryTeamForm, () => {
      // 성공 시 입력 필드 초기화
      setMinistryTeamForm(DEFAULT_MINISTRY_TEAM);
      clearError();
    });
  };

  /**
   * 유효성 검사 에러 메시지
   */
  const validationError = useMemo(() => {
    if (ministryTeamForm.name && validateText(ministryTeamForm.name)) {
      return '특수문자를 입력할 수 없습니다.';
    }
    return '';
  }, [ministryTeamForm.name]);

  /**
   * 통합된 에러 메시지 (유효성 검사 에러 우선, 없으면 API 에러)
   */
  const errMessage = useMemo(() => {
    return validationError || addError || '';
  }, [validationError, addError]);

  /**
   * Enter 키 입력 시 사역팀 추가
   */
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && isSendable) {
      handleAddMinistryTeam();
    }
  };

  /**
   * 제출 가능 여부 확인
   */
  useEffect(() => {
    const isValid = ministryTeamForm.name && !validateText(ministryTeamForm.name);
    setIsSendable(isValid && !isReadOnly);
  }, [ministryTeamForm, isReadOnly]);

  return (
    <>
      <div className="col-xs-12 col-sm-4 col-md-4">
        <div className="styled-group">
          <input
            className="styled-left3"
            value={ministryTeamForm.name}
            placeholder="사역팀 이름을 등록해주세요"
            onChange={(e) => updateField('name', e.target.value)}
            onKeyPress={handleKeyPress}
            disabled={isReadOnly}
            maxLength={10}
          />
          <button className={`styled-right3 ${isSendable && !isLoading ? 'add' : 'disabled'}`} type="button" disabled={!isSendable || isLoading} onClick={handleAddMinistryTeam}>
            {isLoading ? '추가 중...' : '추가'}
          </button>
        </div>
      </div>

      {/* 에러 메시지 */}
      {errMessage && (
        <div className="col-xs-12 col-sm-12 col-md-12">
          <span className={`main-color-important ${styles.errorMessage}`}>* {errMessage}</span>
        </div>
      )}
    </>
  );
};
